import axios from 'axios';

// In dev, CRA proxy handles /api → localhost:3001.
// In production (Vercel), set REACT_APP_API_URL=https://your-backend.railway.app/api
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
